import { gql } from "graphql-request";

const GET_POOL_BY_ID = gql`
    query pool(
        $id: String!
        $code: String
    ) {
        pool (
            findPoolParam: {
                id: $id
                code: $code
            }
        ) {
            id
            ticker
            name
            description
            longDescription
            status
            contributionStartDate
            contributionEndDate
            pledgeStartDate
            pledgeEndDate
            distributionStatus
            distributionStatusDescription
            canPledge
            poolTokenPrice
            image
            banner
            spotlight {
                url
                type
            }
            networks {
                networkId
                address
                token
            }
            totalCap
            maxRaise
            totalRaised
            socialNetworks {
                website
                telegram
                whitePaper
                twitter
            }
            team {
                imageUrl
            }
            roadmap {
                imageUrl
            }
            partners {
                imageUrl
            }
            investments {
                id
                amount
                userId
                walletId
                poolId
                isTrxVerified
                receivingAddress
                totalTokenEarned
                totalTokenClaimed
                totalTokenClaimable
                refundPayload {
                  status
                  requestedDate
                  refundedDate
                }
            }
            vesting {
                date
                percentage
            }
            kycUrl
            kycDeadlineDate
            usdPerTicketValue
            distributionStatusDescription
            distributionScAddress {
                networkId
                token
                address
                chain
                isClaimable
                isAirdropped
            }
            isExternalProject            
            poolStakingConfigs {
                id
                withdrawalRules {
                    duration
                    apy
                }
                earlyWithdrawalPenalty
                networkId
                tokenAddress
                maxCap
                stakingDeadline
                poolStakeAddress
            }
        }
    }
`

export const GET_POOL = gql`
    query pool(
        $id: String
        $slug: String
        $code: String
    ) {
        pool (
            findPoolParam: {
                id: $id
                slug: $slug
                code: $code
            }
        ) {
            id
            ticker
            name
            description
            longDescription
            status
            contributionStartDate
            contributionEndDate
            pledgeStartDate
            pledgeEndDate
            distributionStatus
            distributionStatusDescription
            canPledge
            poolTokenPrice
            image
            banner
            spotlight {
                url
                type
            }
            networks {
                networkId
                address
                token
            }
            totalCap
            maxRaise
            totalRaised
            socialNetworks {
                website
                telegram
                whitePaper
                twitter
            }
            team {
                imageUrl
            }
            roadmap {
                imageUrl
            }
            partners {
                imageUrl
            }
            investments {
                id
                amount
                userId
                walletId
                poolId
                isTrxVerified
                receivingAddress
                totalTokenEarned
                totalTokenClaimed
                totalTokenClaimable
                refundPayload {
                  status
                  requestedDate
                  refundedDate
                }
            }
            vesting {
                date
                percentage
            }
            kycUrl
            kycDeadlineDate
            usdPerTicketValue
            distributionStatusDescription
            distributionScAddress {
                networkId
                token
                address
                chain
                isClaimable
                isAirdropped
            }
            isExternalProject            
            poolStakingConfigs {
                id
                withdrawalRules {
                    duration
                    apy
                }
                earlyWithdrawalPenalty
                networkId
                tokenAddress
                maxCap
                stakingDeadline
                poolStakeAddress
            }
        }
    }
`

export default GET_POOL_BY_ID;